<div class="text-nowrap color-primary-grey font-Medium f-12"> 
    <span class="">{{totalRecords === 0 ? '0' : getStartRange()}} </span>
    - <span class="">{{getEndRange()}} </span> {{"COMMON.PAGESUMMARY.OF"|translate}} <span class="">{{ totalRecords }}</span> {{"COMMON.PAGESUMMARY.ITEMS"|translate}}
</div>